import request from ".";

export const logsApi = {
    get: ({ page, limit }) => request.get(`log?pageSize=${limit}&&pageNumber=${page}`),
}

